<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      :showEdit='!estimate.is_sold'
      @edit='openEdit'

    >
      <v-card-text>
        <span v-if='!estimateDetail.mechanical_notes'>None...</span>
        <span v-html='estimateDetail.mechanical_notes'></span>
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :title='title'
      :icon='icon'
      :iconColor='iconColor'
      :showDialog='showDialog'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-textarea
        v-model='estimateDetailCopy.mechanical_notes'
        outlined
        auto-grow
        hint='Notes to the crew for the mechanical work order only'
        persistent-hint
      ></v-textarea>
    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'mechanical-notes',
  props: {
    estimate: {
      required: true
    },
    estimateDetail: {
      required: true
    }
  },
  data: () => ({
    title: 'Mechanical Notes',
    icon: 'mdi-pipe',
    iconColor: '#b87333',
    estimateDetailCopy: {},
    showDialog: false
  }),
  methods: {
    openEdit () {
      this.estimateDetailCopy = _.cloneDeep(this.estimateDetail)
      this.showDialog = true
    },
    save () {
      this.$emit('updateDetail', this.estimateDetailCopy)
      this.showDialog = false
    }
  }
}
</script>